<template>
  <div class="login-bg">
    <div class="login-container">
      <img src="@/assets/logow.png" alt="Logo" class="login-logo" />
      <form class="login-form" @submit.prevent="handleLogin">
        <hr />
        <div v-if="error" class="error-message">{{ error }}</div>
        <label for="username">Nom d'utilisateur</label>
        <input
          id="username"
          v-model="username"
          type="text"
          placeholder="Nom d'utilisateur"
          required
        />
        <label for="password">Mot de passe</label>
        <input
          id="password"
          v-model="password"
          type="password"
          placeholder="Mot de passe"
          required
        />
        <button type="submit" :disabled="loading">
          {{ loading ? 'CHARGEMENT...' : 'SE CONNECTER' }}
        </button>
      </form>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";
import authService from "@/services/authService";

const username = ref("");
const password = ref("");
const error = ref("");
const loading = ref(false);
const router = useRouter();

const handleLogin = async () => {
  try {
    loading.value = true;
    error.value = "";
    
    const credentials = {
      username: username.value,
      password: password.value,
    };
    
    const response = await authService.login(credentials);
    
    if (response && response.success) {
      // Redirection vers le tableau de bord uniquement si succès
      router.push("/dashboard-assist");
    } else {
      // Rester sur la page de connexion et afficher l'erreur
      error.value = response?.message || "Erreur de connexion";
      // Ne pas rediriger, rester sur la page de login
    }
  } catch (err) {
    console.error("Erreur de connexion:", err);
    // En cas d'erreur inattendue, rester sur la page et afficher l'erreur
    error.value = "Une erreur inattendue s'est produite. Veuillez réessayer.";
    // Ne pas rediriger, rester sur la page de login
  } finally {
    loading.value = false;
  }
};
</script>

<script>
export default {
  name: "LoginView",
};
</script>

<style scoped>
.login-bg {
  min-height: 100vh;
  width: 100vw;
  background: url("@/assets/background.png") no-repeat center center fixed;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
}
.login-container {
  background: rgba(0, 24, 64, 0.7);
  border-radius: 12px;
  padding: 48px 32px 32px 32px;
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 400px;
}
.login-logo {
  width: 220px;
  margin-bottom: 32px;
}
.login-form {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  color: #fff;
}
.login-form h2 {
  text-align: left;
  font-size: 1.2rem;
  font-weight: 700;
  margin-bottom: 8px;
  letter-spacing: 1px;
}
.login-form hr {
  border: none;
  border-top: 1px solid #fff;
  margin-bottom: 24px;
}
.login-form label {
  margin-bottom: 6px;
  font-size: 1rem;
  font-weight: 400;
}
.login-form input {
  margin-bottom: 18px;
  padding: 12px 10px;
  border-radius: 6px;
  border: none;
  font-size: 1rem;
}
.login-form button {
  background: #003a8c;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 14px 0;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  margin-top: 8px;
  transition: background 0.2s;
}
.login-form button:hover:not(:disabled) {
  background: #0050b3;
}
.login-form button:disabled {
  background: #7a8faa;
  cursor: not-allowed;
}
.error-message {
  background-color: rgba(255, 0, 0, 0.2);
  border: 1px solid rgba(255, 0, 0, 0.5);
  border-radius: 4px;
  padding: 10px;
  margin-bottom: 15px;
  color: #fff;
  font-size: 0.9rem;
}
</style>
